import { requiredMessage } from "../utils/common"; // see comment https://stackoverflow.com/questions/6319799/regex-for-validating-postcode-and-phone-number#comment99690762_19371766
var postcodeRegex = function postcodeRegex(value) {
  return !/^(0[289][0-9]{2})|([123456789][0-9]{3})$/.test(value);
};
var VARIANTS = {
  ARHI: "postcode"
};
var validAusPostcode = function validAusPostcode(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error;
  var field = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  if (!value) {
    error = requiredMessage(field);
  } else if (postcodeRegex(value)) {
    error = "Invalid ".concat(field, ".");
  }
  return error;
};
export default validAusPostcode;